import Hero from "@/components/Hero";
import VideoTestimonials from "@/components/VideoTestimonials";
import CallToAction from "@/components/CallToAction";

const Index = () => {
  return (
    <main className="min-h-screen">
      <Hero />
      <VideoTestimonials />
      <CallToAction />
    </main>
  );
};

export default Index;
